"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledRoundel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var styleConfig = {
  s: '56px',
  m: 'var(--spacing-global-space10)',
  l: '80px',
  xl: 'var(--spacing-global-space13)',
  red: {
    background: 'var(--color-functional-tintRed90)',
    fontColour: 'var(--color-base-white)'
  },
  black: {
    background: 'var(--color-functional-tintBlack90)',
    fontColour: 'var(--color-base-white)'
  },
  white: {
    background: 'var(--color-functional-tintWhite90)',
    fontColour: 'var(--color-base-black)'
  }
};
var StyledRoundel = exports.StyledRoundel = _styledComponents["default"].div.attrs({
  className: 'fuse-roundel'
}).withConfig({
  displayName: "styled-roundel__StyledRoundel",
  componentId: "sc-bru6xk-0"
})(["display:flex;justify-content:center;align-items:center;text-align:center;overflow:hidden;", ";"], function (props) {
  return "\n\t\tbackground: ".concat(styleConfig[props.variant].background, ";\n\t\tcolor: ").concat(styleConfig[props.variant].fontColour, ";\n\n\t\t").concat(props.variant === 'white' ? "border: var(--border-width-xs) solid var(--color-base-black);" : "", "\n\n\t\t").concat(props.size === 'responsive' ? "\n\t\t\t\t\theight: 56px;\n\t\t\t\t\twidth: 56px;\n\t\t\t\t\t\t\n\t\t\t\t\t@media screen and (min-width: ".concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\t\t\t\theight: var(--spacing-global-space10);\n\t\t\t\t\t\twidth: var(--spacing-global-space10);\n\t\t\t\t\t}\n\n\t\t\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\t\t\t\theight: 80px;\n\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t}\n\n\t\t\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.xl.minWidth, ") {\n\t\t\t\t\t\theight: var(--spacing-global-space13);\n\t\t\t\t\t\twidth: var(--spacing-global-space13);\n\t\t\t\t\t}") : "\n\t\t\t\t\theight: ".concat(styleConfig[props.size], ";\n\t\t\t\t\twidth: ").concat(styleConfig[props.size], ";\n\t\t\t\t"), ";\n\t");
});
var _default = exports["default"] = StyledRoundel;